export type Background = {
  bgBase: string;
  bgPrimary: string;
  bgSecondary: string;
  bgMenuBase: string;
  bgMenuBase2: string;
  bgMenuPrimary: string;
  bgMenuSecondary: string;
  bgPositive: string;
  bgPositivePrimary: string;
  bgPositiveSecondary: string;
  bgBrand: string;
  bgBrandPrimary: string;
  bgNegative: string;
  bgNegativePrimary: string;
  bgWarning: string;
  bgWarningPrimary: string;
  bgTertiary: string;
  bgTable: string;
};
export type Text = {
  textPrimary: string;
  textSecondary: string;
  textTertiary: string;
  textDisable: string;
  textLink: string;
  textPositive: string;
  textWhite: string;
  textNegative: string;
  textWarning: string;
};
export type Stroke = {
  strokeDefault: string;
  strokeDefault2: string;
  strokeBrand: string;
  strokePositive: string;
  strokePositivePrimary: string;
  strokeNegative: string;
  strokeDefault7: string;
  strokeWarning: string;
  strokeWarningPrimary: string;
  strokeMenu: string;
  strokeGrayOpacity_0_2: string;
};
export type Icon = {
  icDefault: string;
  icPrimary: string;
  icDisable: string;
  icBrand: string;
  icPositive: string;
  icNegative: string;
  icWarning: string;
  icDark: string;
  icLight: string;
};

export interface ColorRoot {
  background: Background;
  text: Text;
  stroke: Stroke;
  icon: Icon;
  colorsBase: ColorsBase;
}

export interface ColorsBase {
  // Blue colors
  blue_00: string;
  blue_0: string;
  blue_1: string;
  blue_2: string;
  blue_3: string;
  blue_4: string;
  blue_5: string;
  blue_6: string;
  blue_7: string;
  blue_8: string;
  blue_9: string;
  blue_10: string;

  // Gray colors
  gray_0: string;
  gray_1: string;
  gray_2: string;
  gray_3: string;
  gray_4: string;
  gray_5: string;
  gray_6: string;
  gray_7: string;
  gray_8: string;
  gray_9: string;
  gray_10: string;
  gray_11: string;

  // Red colors
  red_0: string;
  gray_opacity_0_5: string;
  red_1: string;
  red_2: string;
  red_3: string;
  red_4: string;
  red_5: string;
  red_6: string;
  red_7: string;
  red_8: string;
  red_9: string;

  // Green colors
  green_0: string;
  green_1: string;
  green_2: string;
  green_3: string;
  green_4: string;
  green_5: string;
  green_6: string;
  green_7: string;
  green_8: string;
  green_9: string;

  // Orange colors
  orange_0: string;
  orange_1: string;
  orange_2: string;
  orange_3: string;
  orange_4: string;
  orange_5: string;
  orange_6: string;
  orange_7: string;
  orange_8: string;
  orange_9: string;

  // Violet colors
  violet_0: string;
  violet_1: string;
  violet_2: string;
  violet_3: string;
  violet_4: string;
  violet_5: string;
  violet_6: string;
  violet_7: string;
  violet_8: string;
  violet_9: string;

  // Yellow colors
  yellow_0: string;
  yellow_1: string;
  yellow_2: string;
  yellow_3: string;
  yellow_4: string;
  yellow_5: string;
  yellow_6: string;
  yellow_7: string;
  yellow_8: string;
  yellow_9: string;

  success_0: string;
  success_1: string;
  success_2: string;

  // Gray with opacity
  gray_opacity_0_2: string;
}

export const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
